// extracted by mini-css-extract-plugin
export default {"table-wrapper-top":"GQ_4Qgwi","table-wrapper-body":"cl3KGpih","table-wrapper-bottom":"Wui08_iT","form-field-container":"ERtjIbzu","paginateUI-BulkActions":"VPHiXw3w"};